module.exports = __webpack_public_path__ + "img/红心中级大师@2x.95dd89c9.png";